import { Outlet, Link, useNavigate, router, useParams, RouterProvider } from "react-router-dom";
import { useState, useEffect } from "react";
import { AppValues, API } from "../../Values";
import LoginCheck from "../../LoginCheck/page";
import Cookies from "js-cookie";
export default function CustomerOrderInfo() {
  const navigate = useNavigate();
  //---------CHECK LOGIN------------------------------
  LoginCheck();
  var userinfo = [];
  var Username = "";
  var UserID = "";
  if (Cookies.get("userinfo")) {
    userinfo = JSON.parse(Cookies.get("userinfo"));
    Username = userinfo[0].Name;
    UserID = userinfo[0].ID;
  }
  //--------------------------------------------
  const params = useParams();
  const [order, SetOrder] = useState([
    {
      statue: "",
      type_order: "",
      number_order: "",
      date_add: "",
      service: "",
    },
  ]);
  useEffect(() => {
    GetOrders();
  }, []);
  //-------------------------------------------------------------
  async function GetOrders() {
    try {
      const post = {
        number_order: params.order,
        Action: "OrderInfo",
      };
      const response = await fetch(API.Orders, {
        method: "POST",
        body: JSON.stringify(post),
      });
      const body = await response.json();
      console.log(body);
      SetOrder(body);
    } catch (error) {
      return error;
    }
  }


  async function ReOrder() {
    try {
      if (window.confirm("هل تريد طلب الاوردر   ")) {
        const post = {
          number_order: params.order,
          service: order[0].service,
          Action: "ReNewOrder",
        };
        // console.log(post);
        const response = await fetch(API.Orders, {
          method: "POST",
          body: JSON.stringify(post),
        });
        const body = await response.json();
        // console.log(body.number_order);
        // alert("تم طلب الاوردر بنجاح ");
        navigate(`../Customer/OrderWaiting/${body.number_order}/0`);
      }

    } catch (error) {
      return error;
    }
  }

  const style = {
    fontSize: "14px",
    color: "#666",
    fontWeight: "bold",
  };

  let classStatu = "";
  if (order[0].statue == "جارى التاكيد") {
    classStatu = "text-primary";
  }
  if (order[0].statue == "ملغى") {
    classStatu = "text-danger";
  }
  if (order[0].statue == "جارى التنفيذ") {
    classStatu = "text-orange";
  }
  if (order[0].statue == "جارى التوصيل") {
    classStatu = "text-syan";
  }
  if (order[0].statue == "تم التوصيل") {
    classStatu = "text-green";
  }
  return (
    <>
      <div
        dir="rtl"
        className="row mt-0 text-center0 m-auto p-2 px-2 bg-light shadow"
        style={{ maxWidth: "500px", }}
      >
        <div className="col-1 py-1  bg-light ">
          <i
            onClick={() => navigate(-1)}
            className="fa-solid fa-chevron-right  text-syan mt-2 fs-4"
          ></i>
        </div>
        <div className="col-11 py-1 text-center  bg-light text-white0">
          <h4>{" تفاصيل الطلب "}</h4>
        </div>
        <div className="col-8 pt-2 px-2 shadow  bg-white ">
          <img
            style={{ width: "40px" }}
            src={order[0].logo}
            alt=""
          />
          <span
            className="mx-1"
            style={{
              fontSize: "1.2em",
              color: "#000",
              fontWeight: "bold",
            }}
          >
            {order[0].type_order}
          </span>
        </div>
        <div className="col-4 pt-2 text-center  bg-white shadow">
          <small className="mx-0">{"#" + order[0].number_order} </small>
          <br />
          <small
            className="text-syan"
          >
            {order[0].date_add}
          </small>
        </div>
        <div className="col-12 mt-2 text-center0 w-100  bg-white p-2 shadow0 h-100">
          {order[0].service == "دليفرى" && <>
            <h6> المواد الموصلة</h6>
            <h6 className="text-center0" style={style}>
              {order[0].items}
            </h6>
          </>}
          <h6>بيان التوصيل</h6>
          <h6 style={style}><small className="text-green"> <i className="fa-solid fa-location-dot mx-0"></i> من : </small>{order[0].from_plase}</h6>
          <h6 style={style}><small className="text-green">  <i className="fa-solid fa-location-dot mx-0"></i> الى : </small> {order[0].to_plase}</h6>
          <h6> تكلفة التوصيل</h6>
          {order[0].service == "دليفرى" && <>
            <h6 style={style}> التوصيل :  {order[0].safee + " جنية "}</h6>
            <h6 style={style}> سعر الطلب : {order[0].items_price + " جنية "}</h6>
            <h6 style={style}> الاجمالى :  {parseInt(order[0].safee) + parseInt(order[0].items_price) + " جنية "}</h6>
          </>}
          {order[0].service != "دليفرى" && <>
            <h6 style={style}> التوصيل :  {parseInt(order[0].safee) + parseInt(order[0].items_price) + " جنية "}</h6>
          </>}

        </div>
        <div className="col-12 text-center mb-0  bg-white">
          <span
            onClick={() => ReOrder()}
            className="btn btn-green text-white w-75 fw-bold p-1 fs-4 shadow my-4"
          >
            اعادة طلب الاوردر
          </span>
          <br /><br />
        </div>
      </div>
    </>
  );
}
